import { createContext, useContext } from 'react'
import { Socket } from 'socket.io-client'

export interface SocketContextType {
	socket: Socket | null
	isConnected: boolean
	joinTrip: (tripId: string) => void
	leaveTrip: (tripId: string) => void
	/** Hold incoming realtime invalidations until the returned release is called — for the length of a drag, never a page. */
	holdRealtime: () => () => void
}

export const SocketContext = createContext<SocketContextType | undefined>(undefined)

export const useSocket = (): SocketContextType => {
	const context = useContext(SocketContext)
	if (context === undefined) {
		throw new Error('useSocket must be used within a SocketProvider')
	}
	return context
}
